import logoMark from "../../assets/logo-tw.svg";

/** Pantalla completa mientras MSAL resuelve la interaccion de autenticacion */
export default function Loading() {
  return (
    <div className="auth-loading">
      <div className="auth-loading__ring">
        <div className="auth-loading__mark">
          <img src={logoMark} alt="Teamwork" />
        </div>
      </div>

      <p className="auth-loading__label">Autenticando</p>
      <p className="auth-loading__sub">Verificando tu identidad&hellip;</p>
    </div>
  );
}
